/* selling-price.js — Clean modal, no theme JS interference */

document.addEventListener('click', function(e) {

  /* Open */
  var openBtn = e.target.closest('[data-sp-open]');
  if (openBtn) {
    e.preventDefault();
    var modal = document.getElementById(openBtn.getAttribute('data-sp-open'));
    if (modal) {
      modal.classList.add('sp-open');
      document.body.classList.add('sp-body-open');
    }
    return;
  }

  /* Close via button */
  var closeBtn = e.target.closest('[data-sp-close]');
  if (closeBtn) {
    var modal = document.getElementById(closeBtn.getAttribute('data-sp-close'));
    if (modal) {
      modal.classList.remove('sp-open');
      document.body.classList.remove('sp-body-open');
    }
    /* Clean the URL so success state doesn't persist */
    if (window.location.search.indexOf('contact_posted') !== -1) {
      var cleanUrl = window.location.pathname;
      window.history.replaceState({}, document.title, cleanUrl);
    }
    return;
  }

  /* Close on overlay click */
  if (e.target.classList.contains('sp-modal-overlay')) {
    e.target.classList.remove('sp-open');
    document.body.classList.remove('sp-body-open');
    if (window.location.search.indexOf('contact_posted') !== -1) {
      window.history.replaceState({}, document.title, window.location.pathname);
    }
  }

});

/* Close on Escape */
document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') {
    document.querySelectorAll('.sp-modal-overlay.sp-open').forEach(function(m) {
      m.classList.remove('sp-open');
    });
    document.body.classList.remove('sp-body-open');
    if (window.location.search.indexOf('contact_posted') !== -1) {
      window.history.replaceState({}, document.title, window.location.pathname);
    }
  }
});

/* If page loaded with contact_posted=true, open the relevant modal to show success,
   then clean the URL so refreshing doesn't re-show it */
document.addEventListener('DOMContentLoaded', function() {
  var params = new URLSearchParams(window.location.search);
  if (params.get('contact_posted') === 'true') {
    /* Find the anchor in the URL hash to identify which modal */
    var hash = window.location.hash; /* e.g. #sp-form-123_section--xyz */
    if (hash) {
      /* Extract product ID from form ID pattern: sp-form-{productId}_... */
      var match = hash.match(/sp-form-(\d+)/);
      if (match) {
        var modalId = 'sp-modal-' + match[1];
        var modal = document.getElementById(modalId);
        if (modal) {
          modal.classList.add('sp-open');
          document.body.classList.add('sp-body-open');
        }
      }
    }
    /* Clean URL immediately so back/refresh doesn't re-trigger */
    window.history.replaceState({}, document.title, window.location.pathname);
  }
});
